import React, {useEffect, useRef, useState} from "react";
import ContentHeader from "../../navigation/header/ContentHeader";
import useResizeObserver from "../../../hooks/useResizeObserver";
import useDocumentElementById from "../../../hooks/useDocumentElementById";
import PageFiltersCard from "./PageFiltersCard";
import FilteredContentWrapper from "../../wrappers/FilteredContentWrapper";
import useMobilePageBarsVisibility from "../../../hooks/useMobilePageBarsVisibility";
import usePageFiltersOpenState from "../../../hooks/usePageFiltersOpenState";
import {isDesktop, isMobileHorizontalScreen, isMobileVerticalScreen} from "../../../utils/displayUtils";
import {useSelector} from "react-redux";


export default function PageContent({
                                        tabs, selectedTabName, onSelectTab, onScroll, contentEl, additionalEl,
                                        renderFilters,
                                        displayContentHeader, displaySearchInput, onChangeSearchInput, searchInputAmount,
                                        beforeSearchInputAmount, searchInputValue, searchInputLabel, contentHeaderButtons
                                    }) {
    const leftMenuEl = useDocumentElementById("main-menu");
    const pageHeaderEl = useDocumentElementById("page-header");
    const [contentHeaderEl, setContentHeaderEl] = useState(null);
    const [filtersPanelEl, setFiltersPanelEl] = useState(null);
    const isFilterBlockOpenByBtn = useSelector(state => state.navigationReducer.isFilterBlockOpenByBtn);
    const {restorePersistedOpen} = usePageFiltersOpenState();

    const leftMenuWidth = useResizeObserver(leftMenuEl).width | 0;
    const filtersWidth = useResizeObserver(filtersPanelEl).width | 0;
    const contentHeaderSize = useResizeObserver(contentHeaderEl);
    const contentHeaderHeight = contentHeaderSize.height || 0;
    const layoutMargins = 0;
    const bodyWidth = useResizeObserver(document.body).width | 0;
    const layoutWidth = bodyWidth - leftMenuWidth - filtersWidth + layoutMargins;
    const contentHeaderWidth = isDesktop() ? bodyWidth - leftMenuWidth : bodyWidth;
    const filteredContentWidth = !isFilterBlockOpenByBtn && contentHeaderSize.fullWidth
        ? contentHeaderSize.fullWidth - 10 + "px"
        : undefined;

    const scrollRef = useRef();
    const { onTouchEnd } = useMobilePageBarsVisibility({
        enabled: !isDesktop() && Boolean(pageHeaderEl),
    });
    const shouldRestoreFiltersPersistedOpen = renderFilters && !(isMobileVerticalScreen() || isMobileHorizontalScreen());

    const scrollableStyle = isDesktop() ? null : {paddingTop: (contentHeaderHeight + pageHeaderEl?.offsetHeight) + "px", paddingBottom: "50px"}

    useEffect(() => {
        if (!renderFilters) {
            return;
        }

        restorePersistedOpen({
            allowPersistedState: shouldRestoreFiltersPersistedOpen,
        });
    }, [renderFilters, restorePersistedOpen, shouldRestoreFiltersPersistedOpen]);

    useEffect(() => {
        let _scrollRaf = null;

        const handleScroll = (e) => {
            if (!onScroll || _scrollRaf) return;
            _scrollRaf = requestAnimationFrame(() => {
                _scrollRaf = null;
                onScroll(e.target);
            });
        };
        const scrollEl = scrollRef.current;
        if (scrollEl) {
            scrollEl.addEventListener("scroll",  handleScroll, { passive: true });
        }
        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => {
            if (_scrollRaf) {
                cancelAnimationFrame(_scrollRaf);
            }
            if (scrollEl) {
                scrollEl.removeEventListener("scroll", handleScroll);
            }
            window.removeEventListener("scroll", handleScroll);
        };
    }, [onScroll])

    const getContentEl = () => {
        return (
            renderFilters
                ? <FilteredContentWrapper width={filteredContentWidth}>{contentEl}</FilteredContentWrapper>
                : contentEl
        )
    };

    return (
        <div className="wrapper" onTouchEnd={onTouchEnd}>
            <div className="card">
                {displayContentHeader &&
                    <ContentHeader tabs={tabs} selectedTabName={selectedTabName} onSelectTab={onSelectTab}
                                   containerRef={setContentHeaderEl}
                                   width={contentHeaderWidth}
                                   displaySearchInput={displaySearchInput} onChangeSearchInput={onChangeSearchInput}
                                   searchInputAmount={searchInputAmount} beforeSearchInputAmount={beforeSearchInputAmount}
                                   searchInputLabel={searchInputLabel} searchInputValue={searchInputValue} contentHeaderButtons={contentHeaderButtons}
/>}
                <div className={"card-body"} >
                    <div className="layout" style={{width: layoutWidth + "px"}} id="layout">
                        <div className={"scrollable" + (displayContentHeader ? "" : " full-height")} id="scrollable"
                             ref={scrollRef} style={scrollableStyle}>
                            {getContentEl()}
                        </div>
                        {additionalEl}
                    </div>
                    {renderFilters && (
                        <PageFiltersCard
                            containerEl={filtersPanelEl}
                            containerRef={setFiltersPanelEl}
                            renderContent={renderFilters}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}
